import { render, staticRenderFns } from "./NewSessionButton.vue?vue&type=template&id=66d03858&scoped=true&"
import script from "./NewSessionButton.vue?vue&type=script&lang=ts&"
export * from "./NewSessionButton.vue?vue&type=script&lang=ts&"
import style0 from "./NewSessionButton.vue?vue&type=style&index=0&id=66d03858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d03858",
  null
  
)

export default component.exports